import { Routes, Route, Navigate } from 'react-router-dom'
import { SiteLayout } from './components/SiteLayout'
import { ScrollToTop } from './components/ScrollToTop'
import { ProtectedRoute } from './auth/ProtectedRoute'
import { Home } from './pages/Home'
import { DemandeEnlevement } from './pages/DemandeEnlevement'
import { MentionsLegales } from './pages/MentionsLegales'
import { Confidentialite } from './pages/Confidentialite'
import { Login } from './pages/Login'
import { Admin } from './pages/Admin'

// Toutes les pages publiques partagent l'en-tête + le pied de page.
function Page({ children }: { children: React.ReactNode }) {
  return <SiteLayout>{children}</SiteLayout>
}

export default function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Page><Home /></Page>} />
        {/* Anciennes pages marques → redirigées vers la section carrousel de l'accueil */}
        <Route path="/honda" element={<Navigate to="/#marques" replace />} />
        <Route path="/husqvarna" element={<Navigate to="/#marques" replace />} />
        {/* Page Robots fusionnée dans l'accueil → redirige vers la section #robots */}
        <Route path="/robots" element={<Navigate to="/#robots" replace />} />
        <Route path="/robots/honda" element={<Navigate to="/#robots" replace />} />
        <Route path="/robots/husqvarna" element={<Navigate to="/#robots" replace />} />
        <Route path="/enlevement" element={<Page><DemandeEnlevement /></Page>} />
        {/* Page Contact masquée pour l'instant → redirige vers l'accueil */}
        <Route path="/contact" element={<Navigate to="/" replace />} />
        <Route path="/mentions-legales" element={<Page><MentionsLegales /></Page>} />
        <Route path="/confidentialite" element={<Page><Confidentialite /></Page>} />

        {/* Espace administrateur (connexion optionnelle) */}
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  )
}
